import { CalendarEvent } from '@/types/community/calendar';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}



export const calendarEvents: CalendarEvent[] = [
  {
    id: 'event-1',
    title: 'Reunión de la Junta Directiva',
    description: 'Reunión mensual de la junta directiva de la comunidad',
    start: getRelativeDate(0, 14, 0),
    end: getRelativeDate(0, 16, 0),
    type: 'meeting',
    hostedBy: {
      id: 'emp-1',
      name: 'María González',
      type: 'employee'
    },
    attendees: [
      { id: 'res-1', name: 'Carlos Rodríguez' },
      { id: 'res-2', name: 'Ana Martínez' },
      { id: 'res-3', name: 'Luis Hernández' }
    ],
    notes: 'Se discutirán los presupuestos del próximo trimestre',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-2',
    title: 'Clase de Yoga',
    description: 'Clase de yoga para residentes en el gimnasio',
    start: getRelativeDate(1, 9, 0),
    end: getRelativeDate(1, 10, 0),
    type: 'activity',
    hostedBy: {
      id: 'emp-2',
      name: 'Sofia Fernández',
      type: 'employee'
    },
    attendees: [
      { id: 'res-4', name: 'Elena Rodríguez' },
      { id: 'res-5', name: 'Miguel López' },
      { id: 'res-6', name: 'Carmen García' }
    ],
    notes: 'Traer tu propia colchoneta',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-3',
    title: 'Fiesta de la Piscina',
    description: 'Celebración de verano en la piscina comunitaria',
    start: getRelativeDate(2, 16, 0),
    end: getRelativeDate(2, 20, 0),
    type: 'activity',
    hostedBy: {
      id: 'res-7',
      name: 'Roberto Silva',
      type: 'resident'
    },
    attendees: [
      { id: 'res-8', name: 'Patricia Morales' },
      { id: 'res-9', name: 'Fernando Torres' },
      { id: 'res-10', name: 'Isabel Castro' }
    ],
    notes: 'Habrá música en vivo y refrigerios',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-4',
    title: 'Mantenimiento del Elevador',
    description: 'Mantenimiento programado del elevador del Bloque A',
    start: getRelativeDate(3, 8, 0),
    end: getRelativeDate(3, 12, 0),
    type: 'other',
    hostedBy: {
      id: 'ven-1',
      name: 'Servicios Técnicos ABC',
      type: 'vendor'
    },
    notes: 'El elevador estará fuera de servicio durante 4 horas',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-5',
    title: 'Clase de Cocina',
    description: 'Clase de cocina italiana en la cocina comunitaria',
    start: getRelativeDate(4, 18, 0),
    end: getRelativeDate(4, 20, 0),
    type: 'activity',
    hostedBy: {
      id: 'emp-3',
      name: 'Chef Antonio',
      type: 'employee'
    },
    attendees: [
      { id: 'res-11', name: 'Lucía Mendoza' },
      { id: 'res-12', name: 'Diego Rojas' },
      { id: 'res-13', name: 'Valentina Paredes' }
    ],
    notes: 'Se proporcionarán todos los ingredientes',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-6',
    title: 'Reunión de Seguridad',
    description: 'Reunión para discutir las medidas de seguridad de la comunidad',
    start: getRelativeDate(5, 19, 0),
    end: getRelativeDate(5, 20, 30),
    type: 'meeting',
    hostedBy: {
      id: 'emp-4',
      name: 'Jefe de Seguridad',
      type: 'employee'
    },
    attendees: [
      { id: 'res-14', name: 'Ricardo Vargas' },
      { id: 'res-15', name: 'Adriana Flores' },
      { id: 'res-16', name: 'Héctor Ruiz' }
    ],
    notes: 'Se presentarán las nuevas cámaras de seguridad',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-7',
    title: 'Torneo de Tenis',
    description: 'Torneo de tenis para residentes en las canchas',
    start: getRelativeDate(6, 10, 0),
    end: getRelativeDate(6, 16, 0),
    type: 'activity',
    hostedBy: {
      id: 'res-17',
      name: 'Tennis Club',
      type: 'resident'
    },
    attendees: [
      { id: 'res-18', name: 'Marco Polo' },
      { id: 'res-19', name: 'Natalia Vega' },
      { id: 'res-20', name: 'Oscar Mendoza' }
    ],
    notes: 'Inscripciones abiertas hasta el viernes',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-8',
    title: 'Seminario de Finanzas',
    description: 'Seminario sobre planificación financiera personal',
    start: getRelativeDate(7, 15, 0),
    end: getRelativeDate(7, 17, 0),
    type: 'meeting',
    hostedBy: {
      id: 'emp-5',
      name: 'Asesor Financiero',
      type: 'employee'
    },
    attendees: [
      { id: 'res-21', name: 'Gabriela Soto' },
      { id: 'res-22', name: 'Manuel Herrera' },
      { id: 'res-23', name: 'Rosa Jiménez' }
    ],
    notes: 'Se entregará material informativo',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-9',
    title: 'Limpieza de la Comunidad',
    description: 'Día de limpieza comunitaria voluntaria',
    start: getRelativeDate(8, 8, 0),
    end: getRelativeDate(8, 12, 0),
    type: 'activity',
    hostedBy: {
      id: 'res-24',
      name: 'Comité de Limpieza',
      type: 'resident'
    },
    attendees: [
      { id: 'res-25', name: 'Pedro Alarcón' },
      { id: 'res-26', name: 'Silvia Moreno' },
      { id: 'res-27', name: 'Jorge Pacheco' }
    ],
    notes: 'Se proporcionarán guantes y bolsas',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  },
  {
    id: 'event-10',
    title: 'Mantenimiento del Sistema de Riego',
    description: 'Mantenimiento del sistema de riego automático',
    start: getRelativeDate(9, 7, 0),
    end: getRelativeDate(9, 11, 0),
    type: 'other',
    hostedBy: {
      id: 'ven-2',
      name: 'Jardinería Pro',
      type: 'vendor'
    },
    notes: 'Algunas áreas pueden estar temporalmente sin riego',
    workspace: {
      id: 'workspace-1',
      name: 'Jardines Sunset',
      slug: 'jardines-sunset'
    }
  }
]; 